import React from 'react'
import { Link } from 'react-router-dom';
import './comp_candidate_card.css';
import { useEffect,useState } from 'react';

export const Comp_Candidate_Card=(props)=>{
    //alert(props.member.frd_req_json);
    const [reqStatus,setReqStatus]=useState("");
    //let reqStatus=""
    useEffect(()=>{
        if(typeof props.member.frd_req_json!=="undefined"){
            if(props.member.frd_req_json!==null){
                let tmpFrdReq=JSON.parse(props.member.frd_req_json);
                for(let i=0;i<tmpFrdReq.length;i++){
                    if(tmpFrdReq[i]["req_by_acc_inf_id"].toString()===props.member.account_info_id.toString()){
                        setReqStatus("Reqest Sent");
                    }else if(tmpFrdReq[i]["req_rec_acc_inf_id"].toString()===props.member.account_info_id.toString()){
                        setReqStatus("Request Received")
                    }
                }
            }
        }

        //alert(props.member?.form_request);


    },[props.member]);

    let public_url="";
    return (
        <div class="container mt-4 khandelwal-profile-listingg">
        <div class="profile-card">
            <div class="row">
                <div class="col-auto">
                    <div class="profile-image">
                        <img src="https://www.ejobee.com/assets/images/user_icon.png"/>
                    </div>
                </div>
                <div class="col text-start">
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                           <a href={"javascript:void(0)"}  data-bs-toggle="modal" data-bs-target="#profileModal" onClick={()=>props.onViewProfile(props.member,props.member.req_status)}> <h5 class="profile-name mb-0 ml-2">{props.member["mem_name"]}</h5></a>
                            <div class="gender-tag ml-2">{props.member["gender"]}</div>
                            <span class="experience-tag">
                            <span class="experience-icon"><i class="fa fa-user"></i></span>
                            Request ID: 
                            <b>{props.member["id"]}</b>
                        </span>
                            <span class="experience-tag">
                            <span class="experience-icon"><i class="fa fa-id-card-o"></i></span>
                            Date:
                            <b>{props.member["request_date"]}</b>
                        </span>
                        </div>
                        <div class="text-end d-none d-sm-block">
                           {(props.member.req_status==="Accepted")?<a class="view-profile-btn11 btn-primary" onClick={()=>props.onViewProfile(props.member,props.member.req_status)} href='javascript:void(0)' data-bs-toggle="modal" data-bs-target="#profileModal">View Profile</a>:''} 
                           {(props.member.req_status==="Rejected")?<a class="view-profile-btn11 btn-secondary" href='javascript:void(0)'>Not Interested</a>:''} 
                            {(typeof props.sendReq!=="undefined" && reqStatus==="") ?<a class="view-profile-btn1 btn-secondary ml-2" onClick={()=>props.sendReq(props.member.account_info_id)} href='javascript:void(0)'>Send Request</a>:reqStatus}
                            {/* {typeof props.req_status!=="undefined"?<a class="view-profile-btn1 btn-secondary ml-2" href='javascript:void(0)'>{props.member.req_status}</a>:''} */}
                            {props.member.req_status!=="Accepted" && props.member.req_status!=="Rejected" && typeof props.onAcceptRecject!=="undefined"?<>
                            {(typeof props.member.req_rec_acc_inf_id!=="undefined" && props.member.req_rec_acc_inf_id.toString()===props.member.account_info_id.toString())?<>Request Sent</>:<><a class="view-profile-btn1 btn-primary ml-2" onClick={()=>props.onAcceptRecject(props.member.account_info_id,props.member.mem_frd_req_id,"Accepted")} href='javascript:void(0)'>{"Accept"}</a>
                            <a class="view-profile-btn1 btn-secondary ml-2" onClick={()=>props.onAcceptRecject(props.member.account_info_id,props.member.mem_frd_req_id,"Rejected")} href='javascript:void(0)'>{"Reject"}</a>
                            </>}
                            </>:''}
                            
                        </div>
                    </div>
                    {JSON.parse(props.member?.form_request)?.map((formItem,formIndex)=>{
                        if(formItem.field_type==="text"){

                        
                        return ( <div class="mt-2">
                        <span class="experience-tag">
                                <span class="experience-icon"><i class="fa fa-briefcase"></i></span>
                                {formItem["field_name"]} : <b>{formItem["value"]}</b>
                            </span>
                            {/* <span class="experience-tag">
                                <span class="experience-icon"> <i class="fa fa-map-marker"></i></span>
                                {props.member["city_nm"]}
                            </span> */}
                        </div>)
                        }
                    })}
                   

                    <div class="mt-2">
                    <span class="experience-tag">
                            <span class="experience-icon"><i class="fa fa-inr"></i></span>
                            {props.member["service_cost"]+" Paid"}
                        </span>

                        <span class="experience-tag">
                            <span class="experience-icon"><i class="fa fa-inr"></i></span>
                            {props.member["family_anum"]+" LPA (Family Income)"}
                        </span>

                    </div>
                    
                    <div class="mt-2">
                        <span class="skill-tag">Request for: <b>{props.member["category_name"]} feet</b></span>
                        <span class="skill-tag">Color: <b>{props.member["skin_color"]}</b> </span>
                        <span class="skill-tag">Self Goutra: {props.member["self_goutra"]}</span>
                        <span class="skill-tag">Mama's Goutra: {props.member["mama_goutra"]}</span>
                    </div>
                    {props.member["req_rec_status"]==="Accepted"?
                    <div class="location">
                    <i class="fa fa-home"></i>
                    {props.member["address"]}
                    </div>:''}
                </div>
                <div class="col-12 d-block d-sm-none mt-3 text-center">
                {(props.member.req_status==="Accepted")?<a class="view-profile-btn11 btn-primary" onClick={()=>props.onViewProfile(props.member,props.member.req_status)} href='javascript:void(0)' data-bs-toggle="modal" data-bs-target="#profileModal">View Profile</a>:''} 
                            {(typeof props.sendReq!=="undefined" && reqStatus==="") ?<a class="view-profile-btn1 btn-secondary ml-2" onClick={()=>props.sendReq(props.member.account_info_id)} href='javascript:void(0)'>Send Request</a>:''}
                            {typeof props.req_status!=="undefined"?<a class="view-profile-btn1 btn-secondary ml-2" href='javascript:void(0)'>{props.member.req_status}</a>:''}
                </div>
            </div>
        </div>
    </div>
    )
}
export default Comp_Candidate_Card